import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, } from 'react-bootstrap';
import _ from 'lodash';
import Confirm from '../../../../confirm/Confirm';
import EbillService from '../../../../../service/EbillService';
import FieldSet from '../../../../fieldset/FieldSet';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import Grid from '../../../../grid/Grid';

class GRWaterDetailedAccount extends React.Component {
  constructor(props) {
    super(props);
    this.GR_WATER = 'gr_water';
    this.state = {
      selectedEbilling: null,
      ebillingHeaders: [],
      ebillingRows: [],
    };
  }

  async componentDidMount() {
    await this.fetchEbillingInfo();
  }

  async fetchEbillingInfo() {
    const { account, } = this.props;
    const crieria = {
      serviceOfferingId: this.GR_WATER,
      externalAccountId: account.externalAccountId,
    };

    await EbillService.getEbillCustomers(crieria)
      .then(({ data, }) => {
        const { ebillCustomers, } = data;
        const model = Grid.toModelFromList(ebillCustomers, {
          headerFormatter: value => _.startCase(value.header),
          filter: value => [
            'id',
            'customerId',
            'currentStatus',
            'emailAddress',
            'accountId',
            'externalAccountId',
            'ownerName',
            'address',
            'serviceOfferingId',
          ].includes(value),
        });
        const enrolled = ebillCustomers.filter(customer => customer.currentStatus === 'ENROLLED');
        this.setState({
          ebillingHeaders: model.headers,
          ebillingRows: model.format(enrolled),
        });
      })
      .catch(() => {
        this.setState({
          ebillingHeaders: [],
          ebillingRows: [],
        });
      });
  }

  onEbillSelect(selectedRow) {
    const { ebillingRows, } = this.state;
    const ebill = ebillingRows.find((row) => {
      const { raw, } = row;
      return raw.id === selectedRow.id;
    });

    this.setState({
      selectedEbilling: ebill.raw,
    });
  }

  handleHide = () => {
    this.setState({ status: '', });
  };

  disableEbilling(ebillingHistoryId) {
    this.setState({ isLoading: true, }, () => {
      EbillService.unenrollCustomer(ebillingHistoryId)
        .then(() => {
          this.setState({
            status: (
              <Alert className="mt-2" variant="success">
                <Alert.Heading>Success!</Alert.Heading>
                <p>{`Ebilling with history id ${ebillingHistoryId} has been removed successfully!`}</p>
                <div className="d-flex justify-content-end">
                  <Button onClick={this.handleHide} variant="outline-success">
                    OK
                  </Button>
                </div>
              </Alert>
            ),
          });
        })
        .catch(() => {
          this.setState({
            status: (
              <Alert className="mt-2" variant="danger">
                <Alert.Heading>Oh snap! You got an error!</Alert.Heading>
                <p>{`Unable to remove ebilling history id ${ebillingHistoryId}!`}</p>
                <div className="d-flex justify-content-end">
                  <Button onClick={this.handleHide} variant="outline-danger">
                    OK
                  </Button>
                </div>
              </Alert>
            ),
          });
        })
        .finally(() => {
          this.setState({ isLoading: false, removeEbillingOpen: false, });
        });
    });
  }

  showSelectedEbillingInfo(selectedEbilling) {
    const { isLoading, removeEbillingOpen, status, } = this.state;
    if (!selectedEbilling) {
      return null;
    }

    const handleRemoveEbillingOpen = () => {
      this.setState({ removeEbillingOpen: true, });
    };

    const handleRemoveEbillingClose = () => {
      this.setState({ removeEbillingOpen: false, });
    };

    return (
      <div className="container">
        <p>{`Selected ID: ${selectedEbilling.id}`}</p>
        <hr />
        <div className="row">
          <div className="m-1">
            <button type="button" className="btn btn-danger" onClick={handleRemoveEbillingOpen}>
              Remove Ebilling
            </button>
          </div>
          <Confirm
            isLoading={isLoading}
            title="Remove Ebilling Confirmation"
            content="Are you sure you want to remove this ebilling id?"
            open={removeEbillingOpen}
            onClose={handleRemoveEbillingClose}
            onYes={() => this.disableEbilling(selectedEbilling.ebillingHistoryId)}
            onNo={handleRemoveEbillingClose}
          />
        </div>
        {status}
      </div>
    );
  }

  render() {
    const { selectedEbilling, ebillingHeaders, ebillingRows, } = this.state;
    const { account, } = this.props;

    const items = VerticalLabelList.toList(account, {
      displayFormatter: (value) => {
        const formattedValue = value.split('_').join(' ');
        return _.startCase(formattedValue);
      },
    });

    return (
      <div className="container">
        <div>
          <FieldSet title="Water Account Summary" style={{ maxHeight: '400px', }}>
            <VerticalLabelList items={items} />
          </FieldSet>
        </div>
        <div style={{ marginTop: '20px', }}>
          <FieldSet title="E-billing" style={{ maxHeight: '400px', }}>
            <Grid
              headers={ebillingHeaders}
              rows={ebillingRows}
              onRowSelect={data => this.onEbillSelect(data)}
            />
          </FieldSet>
          {this.showSelectedEbillingInfo(selectedEbilling)}
        </div>
      </div>
    );
  }
}

GRWaterDetailedAccount.propTypes = {
  account: PropTypes.instanceOf(Object).isRequired,
};

export default GRWaterDetailedAccount;
